/** Maintenance is distinct from a service-specific 503 (for example Docuvault). */
export function isMaintenanceResponse(response: { status?: number; headers?: unknown } | undefined): boolean {
  if (response?.status !== 503 || !response.headers) return false;
  const headers = response.headers as { get?: (key: string) => unknown; [key: string]: unknown };
  const retry = typeof headers.get === 'function'
    ? headers.get('Retry-After')
    : headers['retry-after'] ?? headers['Retry-After'];
  return retry !== undefined && retry !== null && retry !== '';
}
